import { isExperimentOn, parseDomain } from '../../utils';
import { CheckTransferInStatus } from '@wix/ambassador-domain-delivery/types';
import { Violation } from '@wix/ambassador-premium-domains-v1-domain-transfer-in-validation-result/types';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { Specs } from '../../constants/Specs';
const VIOLATION_TO_TRANSFER_IN_STATUS = {
  [Violation.DOMAIN_NOT_FOUND]: CheckTransferInStatus.DOMAIN_NOT_FOUND,
  [Violation.DOMAIN_TRANSFER_IN_CLIENT_TRANSFER_PROHIBITED]: CheckTransferInStatus.DOMAIN_LOCKED
};
const toTransferInStatus = violation => VIOLATION_TO_TRANSFER_IN_STATUS[violation] ?? CheckTransferInStatus.TRANSFER_NOT_ALLOWED;
const toParsedDomain = domain => typeof domain === 'string' ? parseDomain(domain) : domain;
export const canTransferInDomainViaValidationService = async _ref => {
  let httpClient = _ref.httpClient,
    domain = _ref.request.domain;
  const parsedDomain = domain ? toParsedDomain(domain) : undefined;
  if (!parsedDomain || parsedDomain.subdomain) {
    return {
      canTransferIn: false
    };
  }
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    checkDomainIsTaken = _await$dynamicLoadApi.checkDomainIsTaken,
    validateDomainTransferability = _await$dynamicLoadApi.validateDomainTransferability;
  const _await$checkDomainIsT = await checkDomainIsTaken({
      domain: parsedDomain.asciiDomain
    }),
    isAvailable = _await$checkDomainIsT.isAvailable;
  if (isAvailable) {
    return {
      canTransferIn: false
    };
  }
  const _await$validateDomain = await validateDomainTransferability({
      domain: parsedDomain.asciiDomain
    }),
    validationResult = _await$validateDomain.validationResult;
  const violations = (validationResult == null ? void 0 : validationResult.violations) ?? [];
  const _ref2 = getPremiumEssentialsSafe() ?? {},
    experiments = _ref2.experiments;
  const toleratedViolations = isExperimentOn(experiments == null ? void 0 : experiments[Specs.BLOCK_TRANSFER_GATE]) ? [] : [Violation.DOMAIN_TRANSFER_IN_CLIENT_TRANSFER_PROHIBITED];
  const blockingViolations = violations.filter(violation => !toleratedViolations.includes(violation));
  const _ref3 = [...blockingViolations, ...violations],
    surfacedViolation = _ref3[0];
  return {
    canTransferIn: blockingViolations.length === 0,
    status: surfacedViolation ? toTransferInStatus(surfacedViolation) : undefined,
    error: violations.includes(Violation.DOMAIN_TRANSFER_IN_CLIENT_TRANSFER_PROHIBITED) ? 'lockedByProvider' : undefined
  };
};
//# sourceMappingURL=canTransferInDomainViaValidationService.js.map